module.exports = __webpack_public_path__ + "static/img/16.52b1977.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/5/zh/16.png
// module id = 88dp
// module chunks = 0